import { Button, ButtonGroup, FormControl, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const AdjustmentSelect = ({
  adjustmentSettings,
  selectedIndex,
  confirmed,
  onChange,
  adjustName,
  disabled,
}) => {
  const getOptionName = (option, index) => {
    return typeof option.label === 'undefined'
      ? `Option #${index + 1}`
      : option.label
  }

  return (
    <FormControl fullWidth>
      <Typography component={'span'}>{adjustName}</Typography>
      <ButtonGroup variant="contained" style={{ boxShadow: 'none' }}>
        {adjustmentSettings.adjustmentValues.map((option, index) => {
          if (getOptionName(option, index) !== 'Unknown') {
            return (
              <Button
                onClick={onChange}
                color={`${
                  confirmed && selectedIndex === index
                    ? 'success'
                    : !confirmed && selectedIndex === index
                    ? 'secondary'
                    : 'error'
                }`}
                data-confirmed={confirmed}
                data-selected={selectedIndex === index}
                value={index}
                key={index}
                disabled={disabled}
              >
                {getOptionName(option, index)}
              </Button>
            )
          }
        })}
      </ButtonGroup>
    </FormControl>
  )
}

AdjustmentSelect.propTypes = {
  adjustmentSettings: PropTypes.any,
  selectedIndex: PropTypes.any,
  confirmed: PropTypes.any,
  onChange: PropTypes.any,
  adjustName: PropTypes.string,
  disabled: PropTypes.bool,
}

export default AdjustmentSelect
